import { render, staticRenderFns } from "./CreateCollegeAdminModal.vue?vue&type=template&id=5dee8d2f&scoped=true&"
import script from "./CreateCollegeAdminModal.vue?vue&type=script&lang=js&"
export * from "./CreateCollegeAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCollegeAdminModal.vue?vue&type=style&index=0&id=5dee8d2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee8d2f",
  null
  
)

export default component.exports